// Querys and Mutations
import {
    GET_WITH_PAGINATION,
    CHANGE_STATUS,
    SAVE,
    UPDATE,
    DELETE,
    ALL_ACTIVE
} from '@/graphql/config/PositionsGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import { Position, PositionWithPagination, FormPosition } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class PositionService {
    async save (form: FormPosition): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: SAVE,
            variables: {
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async update (id: number, form: FormPosition): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async changeStatus (id: number, status: boolean) {
        const result = await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                status: status
            }
        })
        if (result.data?.updatePosition?.id) {
            return {
                success: true,
                errors: []
            }
        } else {
            return {
                success: false,
                errors: 'Error al ejecuar la operación'
            }
        }
    }

    async delete (id: number) {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: false,
            errors: 'Error al ejecuar la operación'
        }
    }

    async getWithPagination (perPage = 10, page = 1): Promise<PositionWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })

        const pagination: Paginator = result.data.positionsWithPagination.paginatorInfo
        const data: [Position] = result.data.positionsWithPagination.data
        const response: PositionWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    async getAllActivated (): Promise<Position[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.positionsActive
    }
}

export default new PositionService()
